import React from 'react';
import { Button, ButtonProps } from '@mui/material';
import { useButtonStyles } from './styles';
import { Spinner } from '../inputAutoComplete/styles';

interface IButtonProps extends ButtonProps {
  children: React.ReactNode;
  disabled?: boolean;
  isLoading?: boolean;
}


function SecondaryButton({ children, isLoading = false, ...props }: IButtonProps) {
  const styles = useButtonStyles();

  return (
    <Button
      className={styles.formButtonSecondary}
      disabled={isLoading || props.disabled}
      {...props}
    >
      {children}
      {isLoading && <Spinner style={{ margin: '0 -10px 0 10px' }} />}
    </Button>
  );
}


export default SecondaryButton;
